import { render, staticRenderFns } from "./formAddress.vue?vue&type=template&id=189ef958&"
import script from "./formAddress.vue?vue&type=script&lang=js&"
export * from "./formAddress.vue?vue&type=script&lang=js&"
import style0 from "./formAddress.vue?vue&type=style&index=0&id=189ef958&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports